class TabChange {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', function () {
      const targets = document.getElementsByClassName('rqmt-tab');
      for (let i = 0; i < targets.length; i++) {
        targets[i].addEventListener('click', changeTab, false);
      }
      function changeTab() {
        document.getElementsByClassName('is-active')[0].classList.remove('is-active');
        this.classList.add('is-active');
        document.getElementsByClassName('is-display')[0].classList.remove('is-display');
        const arrayTabs = Array.prototype.slice.call(targets);
        const index = arrayTabs.indexOf(this);
        document.getElementsByClassName('rqmt-contents__inner')[index].classList.add('is-display');
      };
    }, false);
  }
}

export default TabChange